import { Inject, Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { EMPTY, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { FinderSeoService } from '@finder/shared/services/finder-seo/finder-seo.service';
import { FinderApiConnectorService } from '@finder/shared/services/finder-api-connector/finder-api-connector.service';
import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { UserSelectionStorage } from '@finder/shared/services/user-selection-storage/user-selection-storage.service';
import { TravelAgentService } from '@finder/shared/services/travel-agent/travel-agent.service';

import { GetYMDProvider, GET_YMD } from '@finder/shared/utils/string/getYMD';

@Injectable()
export class CalendarResolver implements Resolve<any> {
    constructor(
        private finderApi: FinderApiConnectorService,
        private finderSeoService: FinderSeoService,
        private loadingService: LoadingService,
        private userSelection: UserSelectionStorage,
        private travelAgentService: TravelAgentService,
        @Inject(GET_YMD) private getYMD: GetYMDProvider,
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        this.loadingService.setErrorState(null);
        this.loadingService.setLoadingState(false);

        // If we try to go to a trade page but we don't have the session cookie, show an error.
        const tradeError = this.travelAgentService.showErrorIfCookieIsMissing();
        if (tradeError) {
            return;
        }

        // month or five-day view.
        const viewType = route.firstChild.data.viewType;
        // Pull stored date from Session Storage.
        const date = this.userSelection.getCalendarDate();

        /**
         * Use a promise to resolve the route and never reject
         * the error so we can stay on the same URI
         */
        return new Promise((resolve, reject) => {
            this.finderApi.getCalendarData(viewType, this.getYMD(date))
                .pipe(
                    catchError(error => {
                        this.loadingService.setErrorState(error);
                        this.loadingService.setLoadingState(true);

                        // Is needed resolve the promise so the url redirection will be carried out
                        // when we want to show our error messaging page
                        resolve(error);

                        // This doesn't really do anything other an stop the error from a
                        // method that wants an Observable returned to it
                        return EMPTY;
                    })
                ).subscribe(result => {
                    // Set SEO
                    this.finderSeoService.getPageKeyAndSetSeo();

                    // Disable loading spinner
                    this.loadingService.setLoadingState(true);

                    resolve(result);
                });
        });
    }
}
